<template>
    <base-composable-checkpoint 
        :draggable="canWrite"
        :name="checkpoint.displayName"
    >
        <template #icon>
            <i :class="checkpoint.iconClass" v-if="checkpoint.iconClass" />
            <img :src="checkpoint.iconPath" v-if="checkpoint.iconPath" draggable="false" />
        </template>
    </base-composable-checkpoint>
</template>

<script>
import {checkpointDefinitions} from "@modules/JourneyBuilder/Bricks/checkpoint-definitions";

import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';

import BaseComposableCheckpoint from "./BaseComposableCheckpoint";

export default {
    name: "normal-composable-checkpoint",
    components: {
        BaseComposableCheckpoint
    },
    mixins: [permissionsMixin],
    props: {
        checkpointName: {
            type: String,
            required: true
        }
    },
    computed: {
        checkpoint(){
            return checkpointDefinitions[this.checkpointName];
        }
    }
}
</script>

<style scoped>
    img {
        width: 2rem;
    }
</style>